export const contacts = {
  EMEA: '+44 2080 394009',
  APAC: '+65 3174-6217',
  US: '+1 888-585-4609',
  email: 'client@altovita.com',
};

export const defaultErrorMessage = 'An unexpected error has occurred,'
    + ' possibly a server or internet problem, you can try again';
